module.exports = "/assets/4bc6e3c05d1d5c9231f1fc8f24cae7eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/FY.png
// module id = 2512
// module chunks = 0